<template>
    <div class="main-container">
        <div class="head-container">
            <div class="form-label">
                <span>名  称：</span>
            </div>
            <div class="form-input">
                <Input v-model="formParam.name"/>
            </div>
            <div class="form-button">
                <Button type="primary" icon="md-search" style="margin-right: 10px" @click="onQuery">查询</Button>
            </div>
        </div>
        <div class="button-container">
            <Button type="primary" icon="md-add" style="margin-right: 20px" @click="showModal">添加商家</Button>
        </div>
        <div class="table-container">
            <Table :columns="columns" :data="tableData">
                <template #action="{ row, index }">
                    <Button class="table-button-edit" size="small" style="margin-right: 5px" @click="edit(row)">编辑</Button>
                    <Poptip
                        confirm
                        title="该商家下所有的门店、员工、会员都会删除，确定删除?"
                        @on-ok="remove(row)" placement="top-start" transfer>
                        <Button class="table-button-remove" size="small">删除</Button>
                    </Poptip>
                </template>
            </Table>
            <div style="margin-top: 10px;text-align: right">
                <Page v-model="formParam.current" :page-size="formParam.size"
                      :total="formParam.total"
                      @on-change="onPageChange"
                      @on-page-size-change="onPageSizeChange"
                      show-sizer show-elevator show-total/>
            </div>
        </div>
        <Modal
            v-model="modal"
            title="新增商家"
            footer-hide>
            <div>
                <Form :model="formItem" :label-width="80" ref="formItem" :rules="rules">
                    <FormItem label="商家名称" prop="name" class="from-item-row">
                        <Input v-model="formItem.name" placeholder="请输入商家名称"></Input>
                    </FormItem>
                    <FormItem label="商家类型" prop="merchantType" class="from-item-row">
                        <Select v-model="formItem.merchantType" filterable>
                            <Option v-for="item in merchantTypes" :value="item.dictValue" :key="item.id">{{ item.dictName }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="logo名称" prop="logoName" class="from-item-row">
                        <Input v-model="formItem.logoName" maxlength="10" show-word-limit placeholder="请输入logo名称"></Input>
                    </FormItem>
                    <FormItem label="联系人" prop="contactsName" class="from-item-row">
                        <Input v-model="formItem.contactsName" placeholder="请输入联系人"></Input>
                    </FormItem>
                    <FormItem label="联系电话" prop="contactsPhone" class="from-item-row">
                        <Input v-model="formItem.contactsPhone" placeholder="请输入联系电话"></Input>
                    </FormItem>
                    <FormItem label="商家logo" prop="address" style="margin-bottom: 5px">
                        <Upload :action="uploadUrl" accept="image/*"
                                :headers="headers" :before-upload="onBeforeUpload" :on-success="onUploadBack">
                            <Button icon="ios-cloud-upload-outline">选择logo</Button>
                        </Upload>
                    </FormItem>
                    <FormItem label="商家地址" prop="address" class="from-item-row">
                        <Input v-model="formItem.address" placeholder="请输入地址"></Input>
                    </FormItem>
                </Form>
                <div slot="footer" style="text-align: right">
                    <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleOk">确定</Button>
                    <Button @click="handleCancel">取消</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import {queryMerchantPage, removeMerchant, saveMerchant} from "@/api"
import {queryDictInfo} from "@/api/baseData"

export default {
    name: "MerchantManage",
    data() {
        return {
            formParam: {
                name: '',
                total: 0,
                current: 1,
                size: 10,
            },
            formItem: {
                name: '',
                merchantType: '',
                logoName: '',
                logoPath: '',
                contactsName: '',
                contactsPhone: '',
                address: '',
            },
            currentUploadPath: undefined,
            headers: {},
            merchantTypes: [],
            modal: false,
            loading: false,
            rules: {
                name: [
                    {required: true, message: '商家名称不能为空', trigger: 'blur'},
                ],
                merchantType: [
                    {required: true, message: '请选择商家类型', trigger: 'blur'},
                ],
                logoName: [
                    {required: true, message: 'logo名称不能为空', trigger: 'blur'},
                ],
                contactsName: [
                    {required: true, message: '联系人不能为空', trigger: 'blur'},
                ],
                contactsPhone: [
                    {required: true, message: '联系电话不能为空', trigger: 'blur'},
                ],
            },
            columns: [
                {
                    title: '商家名称',
                    key: 'name',
                    align: 'left',
                },
                {
                    title: '联系人',
                    key: 'contactsName',
                    align: 'center',
                    width: 100,
                },
                {
                    title: '联系电话',
                    key: 'contactsPhone',
                    align: 'center',
                    width: 150,
                },
                {
                    title: '地址',
                    key: 'address',
                    align: 'center',
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    align: 'center',
                    width: 180,
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 150,
                    align: 'center',
                },
            ],
            tableData: [],
            uploadUrl: '',
        }
    },
    mounted() {
        this.initInfo()
        this.onQuery()
    },
    methods: {
        initInfo() {
            this.uploadUrl = process.env.VUE_APP_BASE_API + "/file/upload/logo"
            this.headers = {
                Authorization: sessionStorage.getItem('token'),
            }
            queryDictInfo({classCode: 'merchant_type'}).then((res) => {
                this.merchantTypes = res.data
            })
        },
        async onQuery() {
            let res = await queryMerchantPage(this.formParam)
            if (res.data != null) {
                this.tableData = res.data
                this.formParam.current = res.current
                this.formParam.total = res.total
            }
        },
        showModal() {
            this.formItem = {
                name: '',
                merchantType: '',
                logoName: '',
                logoPath: '',
                contactsName: '',
                contactsPhone: '',
                address: '',
            }
            this.currentUploadPath = undefined
            this.modal = true
        },
        handleOk() {
            this.loading = true
            this.formItem.logoPath = this.currentUploadPath
            this.$refs.formItem.validate(async (valid) => {
                if (valid) {
                    await saveMerchant(this.formItem)
                    this.loading = false
                    this.modal = false
                    await this.onQuery()
                } else {
                    this.loading = false
                }
            })
        },
        handleCancel() {
            this.modal = false
        },
        edit(row) {
            this.formItem = Object.assign({}, row)
            this.currentUploadPath = row.logoPath
            this.modal = true
        },
        async remove(row) {
            await removeMerchant(row)
            await this.onQuery()
        },
        onPageChange(e) {
            this.formParam.current = e
            this.onQuery()
        },
        onPageSizeChange(e) {
            this.formParam.current = 1
            this.formParam.size = e
            this.onQuery()
        },
        onBeforeUpload() {
            this.currentUploadPath = undefined
        },
        onUploadBack(res) {
            this.currentUploadPath = res.data
        },
    },
}
</script>

<style scoped>
.form-label {
    display: inline-block;
    font-weight: bold;
    margin-left: 10px;
}

.form-input {
    display: inline-block;
    width: 400px;
    margin-right: 15px;
}

.head-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.button-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.form-button {
    display: inline-block;
}

.table-container {
    margin: 10px;
}

.from-item-row {
    margin-bottom: 20px;
}
</style>
